<ng-container *ngIf="page">

  <section class="hero">
    <div class="container">
      <div class="row align-items-center gy-4">
        <div class="col-12 col-lg-6 hero__content">
          <h1 class="hero__title display-2 mb-4">{{ page.heroTitle }}</h1>
          <p class="hero__paragraph mb-3">{{ page.heroParagraph1 }}</p>
          <p class="hero__paragraph mb-4">{{ page.heroParagraph2 }}</p>
          <div class="d-flex flex-column flex-sm-row gap-3">
            <a [routerLink]="[]" fragment="how-can-we-help" class="btn ui-btn ui-btn--primary fw-bold">{{ page.heroPrimaryCtaText }}</a>
            <a [routerLink]="[]" fragment="guidance" class="btn ui-btn ui-btn--outline-light fw-bold">{{ page.heroSecondaryCtaText }}</a>
          </div>
        </div>
        <div class="col-12 col-lg-6">
          <div class="hero__image-wrapper">
            <img [src]="page.heroImageSrc" alt="" class="hero__image w-100">
          </div>
        </div>
      </div>
    </div>
  </section>

  <section class="help py-5" id="how-can-we-help">
    <div class="container">
      <h2 class="help__title display-4 text-center mb-2">{{ page.helpTitle }}</h2>
      <p class="help__subtitle text-center mx-auto mb-5">{{ page.helpSubtitle }}</p>

      <app-icon-card
        class="d-block mb-5"
        [iconSrc]="page.missingCard.iconSrc"
        [title]="page.missingCard.title"
        [description]="page.missingCard.description"
        [ctaText]="ctaTextFor(page.missingCard)"
        [ctaLink]="page.missingCard.ctaLink"
        variant="white"
        [bordered]="true"
      ></app-icon-card>

      <h2 class="help__guidance-title display-5 text-center mb-4" id="guidance">{{ page.guidanceTitle }}</h2>

      <div class="row g-4 mb-4">
        <div class="col-12 col-md-6">
          <app-icon-card
            [iconSrc]="page.foundCard.iconSrc"
            [title]="page.foundCard.title"
            [description]="page.foundCard.description"
            variant="white"
            [bordered]="true"
          ></app-icon-card>
        </div>
        <div class="col-12 col-md-6">
          <app-icon-card
            [iconSrc]="page.lostCard.iconSrc"
            [title]="page.lostCard.title"
            [description]="page.lostCard.description"
            variant="white"
            [bordered]="true"
          ></app-icon-card>
        </div>
      </div>

      <div class="row g-4">
        <div class="col-12 col-md-6">
          <app-guidance-accordion-item [title]="page.foundGuidanceTitle" [bodyHtml]="page.foundGuidanceHtml"></app-guidance-accordion-item>
        </div>
        <div class="col-12 col-md-6">
          <app-guidance-accordion-item [title]="page.lostGuidanceTitle" [bodyHtml]="page.lostGuidanceHtml"></app-guidance-accordion-item>
        </div>
      </div>
    </div>
  </section>

  <app-trust-section [title]="page.trustTitle" [subtitle]="page.trustSubtitle"></app-trust-section>

</ng-container>
